import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import {
  doctorListReducer,
  patientVisitsDetailReducer,
  hospitalListReducer,
  notificationsReducer,
  hardwareListReducer,
  hardwareDetailsReducer,
  firmwareListReducer,
  firmwareDetailsReducer,
} from "./reducers/doctorReducers";
import {
  eegFileReducer,
  eegFilterReducer,
  eegCompareReducer,
} from "./reducers/graphReducers";
import { pwelchPlotReducer } from "./reducers/graphReducers";
import {
  patientCreateReducer,
  patientListReducer,
  patientAdminListReducer,
  patientVisitCreateReducer,
  patientVisitListReducer,
  patientsRecentVisitsListReducer,
  patientVisitDeleteReducer,
  patientVisitDetailsReducer,
  patientVisitsDeleteReducer,
  concussionFormsReducer,
  concussionFormCreateReducer,
  patientDetailReducer,
  patientUpdateReducer,
  concussionFormReducer,
  swayFormsReducer,
  swayFormReducer,
} from "./reducers/patientReducers";
import LoginReducer from "./redux/logins";

const reducer = combineReducers({
  loginData: LoginReducer,
  updatePatient: patientUpdateReducer,
  doctorList: doctorListReducer,
  patientVisitsDetail: patientVisitsDetailReducer,
  patientCreate: patientCreateReducer,
  patientList: patientListReducer,
  patientAdminList: patientAdminListReducer,
  patientDetail: patientDetailReducer,
  patientVisitCreate: patientVisitCreateReducer,
  patientVisitList: patientVisitListReducer,
  patientsRecentVisitsList: patientsRecentVisitsListReducer,
  patientVisitDelete: patientVisitDeleteReducer,
  patientVisitsDelete: patientVisitsDeleteReducer,
  patientVisitDetails: patientVisitDetailsReducer,
  eegGraph: eegFileReducer,
  eegCompareGraphs: eegCompareReducer,
  eegGraphFilter: eegFilterReducer,
  pwelchPlot: pwelchPlotReducer,
  concussionForms: concussionFormsReducer,
  concussionForm: concussionFormReducer,
  concussionFormCreate: concussionFormCreateReducer,
  hospitalList: hospitalListReducer,
  swayForms: swayFormsReducer,
  swayForm: swayFormReducer,
  notifications: notificationsReducer,
  hardwareDevicesList: hardwareListReducer,
  hardwareDevice: hardwareDetailsReducer,
  firmwareList: firmwareListReducer,
  firmwareDevice: firmwareDetailsReducer,
});

const initialState = {};

const middleware = [thunk];

const store = createStore(
  reducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware)),
);

export default store;
